module.exports = __webpack_public_path__ + "static/5-stars-284e01e76502b9e7dc859c0c11149393.png";